import punta_secca from '../../photos/Dintorni/Punta secca.jpg';

import ibla1 from '../../photos/Dintorni/Ibla 1.jpg';
import ibla2 from '../../photos/Dintorni/Ibla 2.jpg';
import ibla3 from '../../photos/Dintorni/Ibla 3.jpg';
import ibla4 from '../../photos/Dintorni/Ibla 4.jpg';
import ibla5 from '../../photos/Dintorni/Ibla 5.jpg';
import ibla6 from '../../photos/Dintorni/Ibla 6.jpg';
import ibla7 from '../../photos/Dintorni/Ibla 7.jpg';

import scicli1 from '../../photos/Dintorni/Scicli 1.jpg';
import scicli2 from '../../photos/Dintorni/Scicli 2.jpg';
import scicli3 from '../../photos/Dintorni/Scicli 3.jpg';
import scicli4 from '../../photos/Dintorni/Scicli 4.jpg';
import scicli5 from '../../photos/Dintorni/Scicli 5.jpg';

import modica1 from '../../photos/Dintorni/Modica 1.jpg';
import modica2 from '../../photos/Dintorni/Modica 2.jpg';
import modica3 from '../../photos/Dintorni/Modica 3.jpg';
import modica4 from '../../photos/Dintorni/Modica 4.jpg';

import ispica1 from '../../photos/Dintorni/Ispica 1.jpg';

import noto1 from '../../photos/Dintorni/Noto 1.jpg';
import noto2 from '../../photos/Dintorni/Noto 2.jpg';
import noto3 from '../../photos/Dintorni/Noto 3.jpg';

import agrigento1 from '../../photos/Dintorni/Agrigento 1.jpg';
import agrigento2 from '../../photos/Dintorni/Agrigento 2.jpg';


const DataDintorni = [
    {
        src: punta_secca,
        title: 'Punta Secca',
        description: '',
    },
    {
        src: ibla1,
        title: 'Ibla',
        description: '',
    },
    {
        src: ibla2,
        title: 'Ibla',
        description: 'Duomo di San Giorgio di Ibla',
    },
    {
        src: ibla3,
        title: 'Ibla',
        description: '',
    },
    {
        src: ibla5,
        title: 'Ibla',
        description: 'Cupola del Duomo di San Giorgio di Ibla',
    },
    {
        src: ibla6,
        title: 'Ibla',
        description: '',
    },
    {
        src: ibla7,
        title: 'Ibla',
        description: '',
    },
    {
        src: scicli1,
        title: 'Scicli',
        description: '',
    },
    {
        src: scicli2,
        title: 'Scicli',
        description: '',
    },
    {
        src: scicli3,
        title: 'Scicli',
        description: '',
    },
    {
        src: scicli4,
        title: 'Scicli',
        description: '',
    },
    {
        src: scicli5,
        title: 'Scicli',
        description: 'Campagne sciclitane',
    },
    {
        src: modica1,
        title: 'Modica',
        description: '',
    },
    {
        src: modica2,
        title: 'Modica',
        description: '',
    },
    {
        src: modica3,
        title: 'Modica',
        description: '',
    },
    {
        src: ibla4,
        title: 'Modica',
        description: 'Portale del Duomo di San Giorgio di Modica',
    },
    {
        src: modica4,
        title: 'Modica',
        description: '',
    },
    {
        src: ispica1,
        title: 'Ispica',
        description: '',
    },
    {
        src: noto1,
        title: 'Noto',
        description: '',
    },
    {
        src: noto2,
        title: 'Noto',
        description: '',
    },
    {
        src: noto3,
        title: 'Noto',
        description: '',
    },
    {
        src: agrigento1,
        title: 'Agrigento',
        description: 'Valle dei Templi di Agrigento',
    },
    {
        src: agrigento2,
        title: 'Agrigento',
        description: 'Valle dei Templi di Agrigento',
    },
]
export default DataDintorni;